var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2233 28.109C34.982 25.3286 36 22.0332 36 18.5C36 8.55887 27.9411 0.5 18 0.5C8.05887 0.5 0 8.55887 0 18.5C0 28.4411 8.05887 36.5 18 36.5C21.5298 36.5 24.8223 35.484 27.601 33.7284L35.2839 35.7826L33.2233 28.109Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24619 15.085C6.82696 9.18553 12.1643 5.29578 17.9951 5.29981V10.5802C14.4965 10.5777 11.2939 12.9116 10.3454 16.4514C9.21352 20.6757 11.7204 25.0178 15.9448 26.1497C20.1691 27.2817 24.5112 24.7747 25.6431 20.5504C25.7191 20.267 25.7786 19.9831 25.8224 19.6997H20.3959V14.8997H25.1982L25.1975 14.8984H30.7089C31.0041 15.9614 31.1708 17.0689 31.1955 18.1972V18.784C31.1889 19.0878 31.1719 19.3927 31.1443 19.6984H31.1398C31.0717 20.4357 30.9405 21.1773 30.7424 21.9167C28.8559 28.9573 21.619 33.1355 14.5784 31.249C7.53787 29.3625 3.35968 22.1256 5.24619 15.085Z",
    fill: "#5B73E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a51df9d1b6d76695642cbf6e89c72ab8.svg";
export { ForwardRef as ReactComponent };